import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=6bf992b2&"
import script from "./MessageTemplate.vue?vue&type=script&lang=js&"
export * from "./MessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf992b2')) {
      api.createRecord('6bf992b2', component.options)
    } else {
      api.reload('6bf992b2', component.options)
    }
    module.hot.accept("./MessageTemplate.vue?vue&type=template&id=6bf992b2&", function () {
      api.rerender('6bf992b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/MessageTemplate.vue"
export default component.exports